import GameSearch from '@/components/GameSearch/GameSearch.example';

export default GameSearch;
